import { render, staticRenderFns } from "./BackgroundSettings.vue?vue&type=template&id=4df0c80a&scoped=true&"
import script from "./BackgroundSettings.vue?vue&type=script&lang=ts&"
export * from "./BackgroundSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df0c80a",
  null
  
)

export default component.exports